// extracted by mini-css-extract-plugin
export default {"nav":"PreviousPage_nav__yjp4i","back":"PreviousPage_back__wpXa2","pages":"PreviousPage_pages__uOW1p","title":"PreviousPage_title__UanmB"};